import { ShopwareSalesChannel } from "../../Dto/ShopwareSalesChannel";

export class SalesChannelToPriceList {

  constructor(
    public salesChannel?: ShopwareSalesChannel,
    public priceList?: string,
    public priceListOrder?: number
  ) {

  }
}



